import { apiClient } from './api';
import type { Restaurant, MenuCategory, SearchResponse } from '@/types';

export const catalogService = {
  async getRestaurants(
    serviceZoneId?: string,
    cityId?: string,
    cuisineCategoryId?: string,
    coordinates?: { latitude: number; longitude: number },
  ) {
    const params = new URLSearchParams();
    if (serviceZoneId) params.set('serviceZoneId', serviceZoneId);
    if (cityId) params.set('cityId', cityId);
    if (cuisineCategoryId && cuisineCategoryId !== 'all') params.set('cuisineCategoryId', cuisineCategoryId);
    if (coordinates) {
      params.set('latitude', String(coordinates.latitude));
      params.set('longitude', String(coordinates.longitude));
    }
    const query = params.toString();
    const response = await apiClient.get<Restaurant[]>(
      `/catalog/restaurants${query ? `?${query}` : ''}`
    );
    return response.data.data;
  },

  async getRestaurant(id: string) {
    const response = await apiClient.get<Restaurant>(`/catalog/restaurants/${id}`);
    return response.data.data;
  },

  async getRestaurantMenu(restaurantId: string) {
    const response = await apiClient.get<{ categories?: MenuCategory[] } | MenuCategory[]>(
      `/catalog/menu/${restaurantId}`,
    );

    const data: any = response.data.data;
    if (Array.isArray(data)) return data as MenuCategory[];
    if (data && Array.isArray(data.categories)) return data.categories as MenuCategory[];
    return [];
  },

  async getPromotions(restaurantId: string) {
    const response = await apiClient.get<any[]>(`/catalog/restaurants/${restaurantId}/promotions`);
    return response.data.data;
  },

  async search(
    query: string,
    options?: {
      serviceZoneId?: string;
      type?: 'all' | 'restaurants' | 'products';
      limit?: number;
      latitude?: number;
      longitude?: number;
    },
  ) {
    const params = new URLSearchParams({ q: query });
    if (options?.serviceZoneId) params.append('serviceZoneId', options.serviceZoneId);
    if (options?.type) params.append('type', options.type);
    if (options?.limit) params.append('limit', String(options.limit));
    if (options?.latitude != null) params.append('latitude', String(options.latitude));
    if (options?.longitude != null) params.append('longitude', String(options.longitude));

    const response = await apiClient.get<SearchResponse>(`/search?${params.toString()}`);
    return response.data.data;
  },
};
